<template>
  <div class="container-home">
    <el-row :gutter="20">
      <!-- 工单数据统计 -->
      <el-col :span="12">
        <el-card class="data-card" shadow="hover">
          <div class="card-header">
            <span class="title">工单数据统计</span>
          </div>
          <div class="data-table">
            <table>
              <thead>
                <tr>
                  <th>类型</th>
                  <th>今年</th>
                  <th>近30天</th>
                  <th>近7天</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in workOrderStats" :key="index">
                  <td>{{ item.label }}</td>
                  <td>{{ item.today }}</td>
                  <td>{{ item.last30Days }}</td>
                  <td>{{ item.last7Days }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
      </el-col>

      <!-- 不通过工单统计 -->
      <el-col :span="12">
        <el-card class="data-card" shadow="hover">
          <div class="card-header">
            <span class="title">不通过(不合格)工单</span>
          </div>
          <div class="data-table">
            <table>
              <thead>
                <tr>
                  <th>类型</th>
                  <th>今年</th>
                  <th>近30天</th>
                  <th>近7天</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in failedOrderStats" :key="index">
                  <td>{{ item.label }}</td>
                  <td>{{ item.today }}</td>
                  <td>{{ item.last30Days }}</td>
                  <td>{{ item.last7Days }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="chart-row">
      <!-- 通过工单趋势图 -->
      <el-col :span="12">
        <el-card class="chart-card" shadow="hover">
          <div class="card-header">
            <span class="title">巡检工单统计(近12个月)</span>
          </div>
          <div class="chart-container" ref="passedTrendChart"></div>
        </el-card>
      </el-col>

      <!-- 不通过工单趋势图 -->
      <el-col :span="12">
        <el-card class="chart-card" shadow="hover">
          <div class="card-header">
            <span class="title">维保工单统计(近12个月)</span>
          </div>
          <div class="chart-container" ref="failedTrendChart"></div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="chart-row">
      <!-- 巡检工单-今年（按园区） -->
      <el-col :span="12">
        <el-card class="chart-card" shadow="hover">
          <div class="card-header">
            <span class="title">巡检工单-今年（按园区）</span>
          </div>
          <div class="chart-container" ref="inspectionChart"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="chart-card" shadow="hover">
          <div class="card-header">
            <span class="title">维保工单-今年（按园区）</span>
          </div>
          <div class="chart-container" ref="maintenanceChart"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="chart-row">
      <el-col :span="24">
        <el-card class="chart-card" shadow="hover">
          <div class="card-header">
            <span class="title">项目点</span>
          </div>
          <div class="chart-container map-container" ref="projectMap"></div>
        </el-card>
      </el-col>
      <!-- 项目线 -->
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts/map/js/china';
import { getHomeDataShow, getMapdata } from '@/api/operation';

export default {
  name: 'FacilityHome',
  data() {
    return {
      workOrderStats: [],
      failedOrderStats: [],
      charts: {
        inspectionChart: null,
        maintenanceChart: null,
        passedTrendChart: null,
        failedTrendChart: null,
        projectMap: null,
      },
      loading: false,
    };
  },
  async created() {
    await this.fetchHomeData();
    this.getMapdatas();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    // 销毁所有图表实例
    Object.values(this.charts).forEach((chart) => {
      if (chart) {
        chart.dispose();
      }
    });
  },
  methods: {
    async fetchHomeData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      try {
        const response = await getHomeDataShow({});
        const res = response.data.data.data;
        // 处理工单统计数据
        this.workOrderStats = res[0].map((item) => ({
          label: `${item.type}工单`,
          today: item.toyear,
          last30Days: item.rec30,
          last7Days: item.rec7,
        }));

        // 处理不通过工单统计数据
        this.failedOrderStats = res[1].map((item) => ({
          label: `${item.type}工单`,
          today: item.toyear,
          last30Days: item.rec30,
          last7Days: item.rec7,
        }));

        this.$nextTick(() => {
          this.initCharts(res);
        });
      } catch (error) {
        console.error('获取首页数据失败:', error);
      } finally {
        loading.close();
      }
    },

    getMapdatas() {
      try {
        getMapdata({}).then((res) => {
          this.$nextTick(() => {
            this.initMap(res.data.data);
          });
        });
      } catch (error) {
        console.error('获取地图数据失败:', error);
      }
    },

    async fetchData() {
      this.loading = true;
      try {
        const response = await getHomeDataShow({});
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },

    handleResize() {
      // 调整所有图表大小
      Object.values(this.charts).forEach((chart) => {
        if (chart) {
          chart.resize();
        }
      });
    },

    initCharts(data) {
      if (!data) return;

      // 确保DOM已经渲染完成
      this.$nextTick(() => {
        if (this.$refs.passedTrendChart) {
          this.initPassedTrendChart(data[2]);
        }
        if (this.$refs.failedTrendChart) {
          this.initFailedTrendChart(data[3]);
        }
        if (this.$refs.inspectionChart) {
          this.initInspectionChart(data[4]);
        }
        if (this.$refs.maintenanceChart) {
          this.initMaintenanceChart(data[5]);
        }
      });
    },

    initInspectionChart(data) {
      const chart = echarts.init(this.$refs.inspectionChart);
      if (!data || !data.length) {
        chart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        });
        this.charts.inspectionChart = chart;
        return;
      }
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          backgroundColor: 'rgba(255,255,255,0.9)',
          borderColor: '#e6e6e6',
          textStyle: {
            color: '#666',
          },
          extraCssText: 'box-shadow: 0 0 10px rgba(0,0,0,0.1);',
        },
        legend: {
          orient: 'vertical',
          left: '5%',
          top: 'center',
          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#666',
          },
          formatter: (name) => {
            const data = option.series[0].data;
            const target = data.find((item) => item.name === name);
            const value = target ? target.value : 0;
            const total = data.reduce((sum, item) => sum + item.value, 0);
            const percentage = ((value / total) * 100).toFixed(2);
            return `${name}  ${value} (${percentage}%)`;
          },
        },
        series: [
          {
            name: '巡检工单',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{c}',
              fontSize: 12,
              color: '#666',
              fontWeight: 'bold',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.2)',
              },
            },
            data: data.map((item, index) => ({
              name: item.name || '未知',
              value: item.value,
              itemStyle: {
                color: [
                  '#5470c6',
                  '#91cc75',
                  '#fac858',
                  '#ee6666',
                  '#73c0de',
                  '#3ba272',
                  '#9a60b4',
                  '#ea7ccc',
                ][index % 8],
              },
            })),
          },
        ],
      };
      chart.setOption(option);
      this.charts.inspectionChart = chart;
    },

    initMaintenanceChart(data) {
      const chart = echarts.init(this.$refs.maintenanceChart);
      if (!data || !data.length) {
        chart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        });
        this.charts.maintenanceChart = chart;
        return;
      }
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
          backgroundColor: 'rgba(255,255,255,0.9)',
          borderColor: '#e6e6e6',
          textStyle: {
            color: '#666',
          },
          extraCssText: 'box-shadow: 0 0 10px rgba(0,0,0,0.1);',
        },
        legend: {
          orient: 'vertical',
          left: '5%',
          top: 'center',
          itemGap: 16,
          textStyle: {
            fontSize: 12,
            color: '#666',
          },
          formatter: (name) => {
            const data = option.series[0].data;
            const target = data.find((item) => item.name === name);
            const value = target ? target.value : 0;
            const total = data.reduce((sum, item) => sum + item.value, 0);
            const percentage = ((value / total) * 100).toFixed(2);
            return `${name}  ${value} (${percentage}%)`;
          },
        },
        series: [
          {
            name: '维保工单',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['60%', '50%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: true,
              position: 'outside',
              formatter: '{c}',
              fontSize: 12,
              color: '#666',
              fontWeight: 'bold',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.2)',
              },
            },
            data: data.map((item, index) => ({
              name: item.name || '未知',
              value: item.value,
              itemStyle: {
                color: [
                  '#5470c6',
                  '#91cc75',
                  '#fac858',
                  '#ee6666',
                  '#73c0de',
                  '#3ba272',
                  '#9a60b4',
                  '#ea7ccc',
                ][index % 8],
              },
            })),
          },
        ],
      };
      chart.setOption(option);
      this.charts.maintenanceChart = chart;
    },
    initPassedTrendChart(data) {
      const chart = echarts.init(this.$refs.passedTrendChart);
      if (!data || !data.length) {
        chart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        });
        this.charts.passedTrendChart = chart;
        return;
      }
      const months = this.get_month();

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: months,
          axisLine: {
            lineStyle: {
              color: '#000',
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#E5E9F2',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            name: '工单数',
            type: 'bar',
            data: data,
            itemStyle: {
              color: '#67C23A',
            },
            barWidth: '40%',
            emphasis: {
              itemStyle: {
                color: '#85CE61',
              },
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#67C23A',
                fontWeight: 'bold',
              },
            },
          },
        ],
      };

      chart.setOption(option);
      this.charts.passedTrendChart = chart;
    },
    initFailedTrendChart(data) {
      const chart = echarts.init(this.$refs.failedTrendChart);
      if (!data || !data.length) {
        chart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        });
        this.charts.failedTrendChart = chart;
        return;
      }
      const months = this.get_month();

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: months,
          axisLine: {
            lineStyle: {
              color: '#000',
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#E5E9F2',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            name: '工单数',
            type: 'bar',
            data: data,
            itemStyle: {
              color: '#F56C6C',
            },
            barWidth: '40%',
            emphasis: {
              itemStyle: {
                color: '#F78989',
              },
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#F56C6C',
                fontWeight: 'bold',
              },
            },
          },
        ],
      };

      chart.setOption(option);
      this.charts.failedTrendChart = chart;
    },
    initPassedRegionChart() {
      const chart = echarts.init(this.$refs.passedRegionChart);
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          left: 10,
          data: ['青岛-黄岛', '北京-亦庄', '河北-正定', '北京-大兴', '其他-其他', '北京-昌平'],
        },
        series: [
          {
            name: '区域分布',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 3203, name: '青岛-黄岛', itemStyle: { color: '#409EFF' } },
              { value: 2388, name: '北京-亦庄', itemStyle: { color: '#67C23A' } },
              { value: 2288, name: '河北-正定', itemStyle: { color: '#E6A23C' } },
              { value: 977, name: '北京-大兴', itemStyle: { color: '#F56C6C' } },
              { value: 794, name: '其他-其他', itemStyle: { color: '#909399' } },
              { value: 476, name: '北京-昌平', itemStyle: { color: '#B0C4DE' } },
            ],
          },
        ],
      };

      chart.setOption(option);
      this.charts.passedRegion = chart;
    },
    get_month() {
      let dates = [];
      let today = new Date();

      for (let i = 0; i < 12; i++) {
        let month = (today.getMonth() + 1).toString();
        let year = today.getFullYear().toString().slice(-2);
        dates.push(`${year}.${month}`);

        // 将月份减去一个月
        today.setMonth(today.getMonth() - 1);
      }

      return dates;
    },
    initMap(data) {
      const chart = echarts.init(this.$refs.projectMap);

      if (!data || !data.length) {
        chart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        });
        this.charts.projectMap = chart;
        return;
      }

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.data.campus}<br/>项目类型：${params.data.project_type}<br/>客户：${params.data.customer}`;
          },
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderColor: 'rgba(200, 200, 200, 0.3)',
          textStyle: {
            color: '#333',
            fontSize: 12,
          },
          extraCssText:
            'backdrop-filter: blur(4px); border-radius: 8px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);',
        },
        geo: {
          map: 'china',
          roam: true,
          scaleLimit: {
            min: 1,
            max: 5,
          },
          label: {
            show: true,
            color: '#666',
          },
          itemStyle: {
            areaColor: '#f5f7fa',
            borderColor: '#d1e4ff',
            borderWidth: 1,
          },
          emphasis: {
            itemStyle: {
              areaColor: '#e6f7ff',
            },
            label: {
              color: '#333',
            },
          },
        },
        series: [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: data.map((item) => ({
              name: item.name,
              value: item.value,
              campus: item.campus,
              project_type: item.project_type,
              customer: item.customer,
            })),
            symbolSize: 12,
            showEffectOn: 'render',
            rippleEffect: {
              period: 4,
              scale: 3,
              brushType: 'stroke',
            },
            label: {
              show: false,
              position: 'top',
              distance: 5,
              formatter: '{b}',
              color: '#666',
              fontSize: 12,
            },
            emphasis: {
              scale: true,
              label: {
                show: true,
              },
              itemStyle: {
                color: '#6366F1',
                borderColor: '#fff',
                borderWidth: 2,
                shadowBlur: 10,
                shadowColor: 'rgba(99, 102, 241, 0.3)',
              },
            },
            itemStyle: {
              color: '#4B79E5',
              borderColor: '#fff',
              borderWidth: 2,
              shadowBlur: 5,
              shadowColor: 'rgba(75, 121, 229, 0.3)',
            },
          },
        ],
      };

      chart.setOption(option);
      this.charts.projectMap = chart;
    },

    getCoordinates(city, district) {
      const coordinatesMap = {
        '北京-亦庄': [116.47674, 39.78506],
        '天津-滨海': [117.70494, 39.01846],
        '天津-滨海高新': [117.69354, 39.11296],
        '张家口-怀来瑞北': [115.51734, 40.39869],
        '南京-江宁': [118.85065, 31.95455],
        '仪征-东方': [119.18244, 32.27201],
        '贵阳-贵安七星': [106.65338, 26.59904],
        '清远-清新': [113.01717, 23.73469],
        '深圳-腾讯大厦': [113.93041, 22.54486],
        '深圳-滨海大厦': [114.04019, 22.52278],
      };
      return coordinatesMap[`${city}-${district}`] || [];
    },
  },
};
</script>

<style lang="less" scoped>
.container-home {
  padding: 20px;
  .title {
    margin: 10px 0;
    padding-left: 10px;
    border-left: 3px solid #219aff;
    font-weight: normal;
  }
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .data-card {
    height: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .card-header {
      padding: 15px 20px;
      .title {
        margin: 10px 0;
        padding-left: 10px;
        border-left: 3px solid #219aff;
        font-weight: normal;
      }
    }

    .data-table {
      padding: 20px;

      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;

        th,
        td {
          padding: 12px 8px;
          text-align: center;
          border-bottom: 1px solid #ebeef5;
        }

        th {
          background-color: #f5f7fa;
          color: #606266;
          font-weight: 500;
        }

        td {
          color: #303133;
        }

        tbody tr:hover {
          background-color: #f5f7fa;
        }

        tbody tr:last-child td {
          border-bottom: none;
        }
      }
    }

    .data-grid {
      padding: 24px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;

      .data-item {
        .data-content {
          background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          }

          .main-info {
            margin-bottom: 16px;

            .label-wrapper {
              display: flex;
              align-items: center;
              margin-bottom: 12px;

              .label {
                font-size: 15px;
                color: #606266;
                font-weight: 500;
              }

              .info-icon {
                margin-left: 8px;
                font-size: 16px;
                color: #909399;
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                  color: #409eff;
                }
              }

              .warning-icon {
                margin-left: 8px;
                font-size: 16px;
                color: #e6a23c;
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                  color: #f56c6c;
                }
              }
            }

            .number {
              font-size: 32px;
              font-weight: bold;
              display: block;
              line-height: 1.2;
              margin-top: 8px;

              &.success {
                color: #67c23a;
              }
              &.info {
                color: #909399;
              }
              &.warning {
                color: #e6a23c;
              }
              &.failed {
                color: #f56c6c;
              }
            }
          }

          .trend-info {
            display: flex;
            justify-content: space-between;
            padding-top: 16px;
            border-top: 1px dashed #ebeef5;

            .trend-item {
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              .trend-label {
                font-size: 13px;
                color: #909399;
                margin-bottom: 6px;
              }

              .trend-value {
                font-size: 16px;
                font-weight: 600;
                color: #606266;
                display: flex;
                align-items: center;

                &.success {
                  color: #67c23a;
                }
                &.info {
                  color: #909399;
                }
                &.warning {
                  color: #e6a23c;
                }
                &.failed {
                  color: #f56c6c;
                }
              }

              .trend-icon {
                margin-left: 6px;
                font-size: 14px;
                color: #67c23a;

                &.down {
                  color: #f56c6c;
                }
              }
            }
          }
        }
      }
    }
  }

  .chart-card {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;

    .card-header {
      padding: 15px 20px;
    }

    .chart-container {
      height: 300px;
      padding: 20px;
    }

    .map-container {
      height: 600px;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.05);
      background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
    }
  }
}
</style>